import { Service } from '@/tools'
export class LossReportFormService<T extends TStock.LossReportForm> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.LossReportForm}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：分页查询报损单列表
   * /api/stock/lossReportForm/v1/page
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：编辑报损单
   *   /api/stock/lossReportForm/v1/edit
   */
  edit = (data: T['ApiEdit']['req']): Promise<T['ApiEdit']['res']> => this.post2('v1/ApiEdit', data)

  /**
   * 功能：查看报损单详情
   *    /api/stock/lossReportForm/v1/detail
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)

  /**
   * 功能：报损单审核
   *    /api/stock/lossReportForm/v1/audit
   */
  audit = (data: T['ApiAudit']['req']): Promise<T['ApiAudit']['res']> => this.post2('v1/ApiAudit', data)

  /**
   * 功能：添加报损单
   *    /api/stock/lossReportForm/v1/add
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：查询业务组成员
   *     /api/stock/lossReportForm/v1/getGroupUsers
   */
  getGroupUsers = (data: T['ApiGetGroupUsers']['req']): Promise<T['ApiGetGroupUsers']['res']> => this.post2('v1/ApiGetGroupUsers', data)
            
  /**
   * 功能：删除报损单
   */
  deleteById = (data: T['ApiDeleteById']['req']): Promise<T['ApiDeleteById']['res']> => this.post2('v1/ApiDeleteById', data)
}
